var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    transform: "rotate(-90 10 10)",
    fill: "#e8eaed"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 14.4113 5.58866 18 10 18C14.4113 18 18 14.4113 18 10C18 5.58866 14.4113 2 10 2C5.58866 2 2 5.58866 2 10ZM10.4713 7.52866L13.8047 10.862C13.9347 10.992 14 11.1627 14 11.3333C14 11.504 13.9347 11.6747 13.8047 11.8047C13.544 12.0653 13.1227 12.0653 12.862 11.8047L10 8.94266L7.138 11.8047C6.87734 12.0653 6.456 12.0653 6.19534 11.8047C5.93469 11.544 5.93469 11.1227 6.19534 10.862L9.52869 7.52866C9.78934 7.268 10.2107 7.268 10.4713 7.52866Z",
    fill: "#1a2b5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxCollapse);
export default __webpack_public_path__ + "static/media/tx-collapse.6e0bf80016b2b1ce2aaaa3800b2677b7.svg";
export { ForwardRef as ReactComponent };